import { render } from "./SignupComponent.vue?vue&type=template&id=d8aee5d2&scoped=true"
import script from "./SignupComponent.vue?vue&type=script&lang=js"
export * from "./SignupComponent.vue?vue&type=script&lang=js"

import "./SignupComponent.vue?vue&type=style&index=0&id=d8aee5d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8aee5d2"]])

export default __exports__